import { useEffect } from 'react';
import { usePage, PAGES } from '../../context/PageContext';
import { getArticle } from '../../config/articles';
import { DOMAIN_TAG_COLOR, resolveTagDomain } from '../../config/data';
import { JOIN_US } from '../../config/data';
import { t } from '../../utils/i18n';
import './index.css';

export default function ArticleDetailPage() {
    const { articleId, navigate } = usePage();
    const article = getArticle(articleId);

    useEffect(() => {
        if (article) {
            document.title = `${article.title} · ${t('至知创新研究院', 'IQuest Research')}`;
        }
    }, [article]);

    if (!article) {
        return (
            <div className="article-detail-page">
                <div className="article-detail-container">
                    <p>{t('文章未找到', 'Article not found')}</p>
                    <button
                        type="button"
                        className="article-detail-back"
                        onClick={() => navigate(PAGES.UPDATES)}
                    >
                        {t('返回动态', 'Back to Updates')}
                    </button>
                </div>
            </div>
        );
    }

    const domain = resolveTagDomain(article.tag);
    const colorClass = DOMAIN_TAG_COLOR[domain] || 'tag-neutral';

    return (
        <div className="article-detail-page">
            <div className="article-detail-container">
                <button
                    type="button"
                    className="article-detail-back"
                    onClick={() => navigate(PAGES.UPDATES)}
                >
                    ← {t('返回动态', 'Back to Updates')}
                </button>
                <header className="article-detail-header">
                    <span className={`article-detail-tag ${colorClass}`}>{article.tag}</span>
                    <h1 className="article-detail-title">{article.title}</h1>
                    <time className="article-detail-date">{article.date}</time>
                </header>
                <article className="article-detail-body">
                    {article.content.map((block, idx) => {
                        switch (block.type) {
                            case 'heading':
                                return <h2 key={idx} className="article-detail-h2">{block.text}</h2>;
                            case 'paragraph':
                                return <p key={idx} className="article-detail-p">{block.text}</p>;
                            case 'bold-paragraph':
                                return (
                                    <p key={idx} className="article-detail-p">
                                        <strong>{block.bold}</strong>{block.text}
                                    </p>
                                );
                            case 'image':
                                return (
                                    <figure key={idx} className="article-detail-figure">
                                        <img src={block.src} alt={block.alt} loading="lazy" />
                                    </figure>
                                );
                            case 'cta':
                                return (
                                    <p key={idx} className="article-detail-cta">
                                        {block.text.replace(/加入我们|join us/i, '')}
                                        <a
                                            href={JOIN_US.href}
                                            target={JOIN_US.target}
                                            rel="noreferrer"
                                            className="article-detail-cta-link"
                                        >
                                            {t('加入我们', 'Join Us')}
                                        </a>
                                        {t('，一起写下更多"真实价值的证明"。', ', and write more "proofs of real value" together.')}
                                    </p>
                                );
                            default:
                                return null;
                        }
                    })}
                </article>
            </div>
        </div>
    );
}
